module.exports = __webpack_public_path__ + "static/media/company-name.eab6731c.png";